/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Modal } from 'antd';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
import { Fragment } from 'react';

type HelpModalProps = {
  visible: boolean;
  onClose: () => void;
  headerId: string;
};

const StatusIcon = ({ icon, color }: { icon: any; color: string }) => (
  <FontAwesomeIcon icon={icon} style={{ color, marginRight: 6 }} />
);

const HelpEN = () => (
  <Fragment>
    <span className="help-head">Q&A head en</span>
    <span className="help-text">Q&A help-text en</span>
    <span className="help-text">Q&A help-text en</span>
    <span className="help-text">Q&A help-text en</span>
    <br />
  </Fragment>
);

const HelpDA = () => (
  <Fragment>
    <span className="help-head">Q&A head da</span>
    <span className="help-text">Q&A help-text da</span>
    <span className="help-text">Q&A help-text da</span>
    <span className="help-text">Q&A help-text da</span>
    <br />
  </Fragment>
);

const getHelpComponent = (locale: string) => {
  switch (locale) {
    case 'da':
      return <HelpDA />;
    default:
      return <HelpEN />;
  }
};

export const QuestionAnswerHelpInfoModal = ({
  visible,
  onClose,
  headerId,
}: HelpModalProps) => {
  const intl = useIntl();
  const styles = useStyles(styleFn);

  return (
    <Modal
      visible={visible}
      title={intl.formatMessage({ id: headerId })}
      onCancel={onClose}
      footer={null}
      width={700}>
      <div css={styles.helpContent}>{getHelpComponent(intl.locale)}</div>
    </Modal>
  );
};

export const styleFn: ThemedStyleFn = (theme) => ({
  helpContent: {
    '.help-head': {
      display: 'block',
      fontSize: 18,
      fontWeight: 'bold',
      marginTop: 18,
      marginBottom: 8,
      color: theme.colors.darkGray ?? '#333',
    },
    '.help-sub-head': {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 600,
      marginTop: 14,
      color: theme.colors.black ?? '#444',
      gap: 8,
    },
    '.help-text': {
      display: 'block',
      fontSize: 14,
      margin: '4px 0 8px',
      color: theme.colors.black ?? '#666',
    },
  },
});
